import React, { ReactNode, useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import { Flex, ChevronDownIcon, FlexProps } from 'vvs-uikit'

export type BaseCollapseProps = {
  initIsExpand?: boolean
  title: ReactNode
  children: ReactNode
  arrowColor?: string
  titleBarProps?: FlexProps
  contentWrapperProps?: FlexProps
}

const BaseCollapse = React.forwardRef<HTMLDivElement, BaseCollapseProps>((props, ref) => {
  const { initIsExpand = false, title, arrowColor, children, contentWrapperProps, titleBarProps } = props
  const [isExpand, setIsExpand] = useState(initIsExpand)

  return (
    <Flex ref={ref} flexDirection="column" width="100%">
      <Flex onClick={() => setIsExpand(!isExpand)} justifyContent="space-between" {...titleBarProps}>
        {title}
        <ArrowIcon color={arrowColor || 'primary'} toggled={isExpand} />
      </Flex>
      <CollapseContent expanded={isExpand} contentWrapperProps={contentWrapperProps}>
        {children}
      </CollapseContent>
    </Flex>
  )
})

export default BaseCollapse

const ArrowIcon = styled(ChevronDownIcon)<{ toggled: boolean }>`
  transform: ${({ toggled }) => (toggled ? 'rotate(180deg)' : 'rotate(0)')};
  height: 35px;
  width: 35px;
  cursor: pointer;
`

const CollapseContent: React.FC<{ expanded: boolean; contentWrapperProps?: FlexProps }> = ({
  expanded,
  children,
  contentWrapperProps,
}) => {
  const contentWrapper = useRef<HTMLDivElement>()
  const [maxHeight, setMaxHeight] = useState<number | undefined>()
  const ready = useRef(false)

  useEffect(() => {
    if (expanded) {
      if (ready.current) {
        setMaxHeight(contentWrapper.current.clientHeight + 100)
      } else {
        setTimeout(() => {
          setMaxHeight(contentWrapper.current.clientHeight + 100)
        }, 100)
      }
    } else {
      setMaxHeight(0)
    }

    ready.current = true
  }, [expanded])

  return (
    <CollapseFlex style={{ maxHeight }}>
      <Flex ref={contentWrapper} {...contentWrapperProps}>
        {children}
      </Flex>
    </CollapseFlex>
  )
}

const CollapseFlex = styled(Flex)`
  transition: max-height 300ms;
  background: ${({ theme }) => theme.colors.paleYellow};
  overflow: hidden;
  width: 100%;
  flex-direction: column;
`
